import React from 'react'
import Hero from '../components/Hero'
import VentureTrailers from '../components/VentureTrailers'
import TrailerFinder from '../components/TrailerFinder'
import Contact from '../components/Contact'
import SEOHead from '../components/SEOHead'

const Home: React.FC = () => {
  return (
    <div>
      <SEOHead
        title="Fast Boat Trailers - Premium Marine Transport Solutions"
        description="Fast Boat Trailers in Edgewater, MD offers premium aluminum and galvanized boat trailers. Expert boat hauling solutions for all marine transportation needs."
        keywords="boat trailers, marine transport, boat hauling, trailer dealer, aluminum trailers, galvanized trailers, Edgewater MD, Maryland boat trailers"
        ogTitle="Fast Boat Trailers - Premium Marine Transport Solutions"
        ogDescription="Fast Boat Trailers in Edgewater, MD offers premium aluminum and galvanized boat trailers. Expert boat hauling solutions for all marine transportation needs."
        ogImage="/images/logos/fbt-logo-3-noborder.jpeg"
        canonical="https://fastboattrailers.com/"
      />
      <Hero />
      <VentureTrailers />
      <div id="trailer-finder">
        <TrailerFinder />
      </div>
      <Contact />
    </div>
  )
}

export default Home